import type { CompanyByUuidResponse } from "@/common/api/company/use-company-by-uuid.query";
import { DetailTabCard } from "@/components/detail-page/_components/tab/detail-tab-card";
import { DetailTabGrid } from "@/components/detail-page/_components/tab/detail-tab-grid";
import { DetailTabRow } from "@/components/detail-page/_components/tab/detail-tab-row";
import { RelationLink } from "@/components/relation-link/relation-link";
import { renderCompanyType } from "@/modules/masterdata/company/_helpers/type-renderer";
import { Building2 } from "lucide-react";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

export function OverviewTab({ company }: { company: CompanyByUuidResponse }): ReactElement {
  const { t } = useTranslation(["masterdata", "common"]);

  return (
    <DetailTabGrid>
      <DetailTabCard icon={Building2} title={t("masterdata:CompanyInformation")}>
        <DetailTabRow label={t("common:Name")} value={company.name} />
        <DetailTabRow label={t("masterdata:Type")} value={renderCompanyType(company.type)} />
        <DetailTabRow
          label={t("masterdata:CompanyGroup")}
          value={
            company.companyGroup ? (
              <RelationLink subject="CompanyGroup" uuid={company.companyGroup.uuid}>
                {company.companyGroup.name}
              </RelationLink>
            ) : undefined
          }
        />
        <DetailTabRow label={t("masterdata:CompanyVatId")} value={company.vatId} mono />
        <DetailTabRow label={t("masterdata:CompanyCommercialRegisterCourt")} value={company.commercialRegisterCourt} />
        <DetailTabRow label={t("masterdata:CompanyRegisterNumber")} value={company.commercialRegisterNumber} mono />
      </DetailTabCard>
    </DetailTabGrid>
  );
}
